import { invokeApi } from "../bl_libs/invokeApi";

export const get_support_tickets_api = async (data) => {
  const requestObj = {
    path: `api/support_tickets/list`,
    method: "POST",
    headers: {
      "Authorization": `Bearer ${localStorage.getItem("token")}`,
    },
    postData: data,
  };
  return invokeApi(requestObj);
};

export const update_multiple_status_api = async (data) => {
  const requestObj = {
    path: `api/support_tickets/update_multiple_status`,
    method: "POST",
    headers: {
      "Authorization": `Bearer ${localStorage.getItem("token")}`,
    },
    postData: data,
  };
  return invokeApi(requestObj);
};

export const update_support_tickets_api = async (data, case_id) => {
  const requestObj = {
    path: `api/support_tickets/update/${case_id}`,
    method: "POST",
    headers: {
      "Authorization": `Bearer ${localStorage.getItem("token")}`,
    },
    postData: data,
  };
  return invokeApi(requestObj);
};


export const get_case_count_api = async () => {
  const requestObj = {
    path: `api/support_tickets/case_count`,
    method: "GET",
    headers: {
      "Authorization": `Bearer ${localStorage.getItem("token")}`,
    },
  };
  return invokeApi(requestObj);
};

export const get_ticket_detail_api = async (case_id) => {
  const requestObj = {
    path: `api/support_tickets/detail/${case_id}`,
    method: "GET",
    headers: {
      "Authorization": `Bearer ${localStorage.getItem("token")}`,
    },
  };
  return invokeApi(requestObj);
};


export const add_support_tickets_api = async (data) => {
  const requestObj = {
    path: `api/support_tickets/create`,
    method: "POST",
    headers: {
      "Authorization": `Bearer ${localStorage.getItem("token")}`,
    },
    postData: data,
  };
  return invokeApi(requestObj);
};
export const get_ticket_trash_api = async (case_id) => {
  const requestObj = {
    path: `api/support_tickets/trash/${case_id}`,
    method: "POST",
    headers: {
      "Authorization": `Bearer ${localStorage.getItem("token")}`,
    },
  };
  return invokeApi(requestObj);
};